(function () {
  'use strict';
  function enhance(configElement) {
    var config;
    try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
    var root = document.getElementById('shopify-section-' + config.sectionId);
    if (!root) return;
    var ratingRow = root.querySelector('.elite-rating-heading-row');
    var ratingWidget = ratingRow && ratingRow.querySelector('.custom-vstar-rating-widget');
    var ratingObserver;
    if (ratingWidget && !ratingWidget.dataset.clipperRatingReady) {
      ratingWidget.dataset.clipperRatingReady = 'true';
      var syncRating = function () {
        var count = ratingWidget.textContent.match(/([\d,]+)\s*reviews?\b/i);
        var hasReviews = count && Number(count[1].replace(/,/g, '')) > 0;
        ratingRow.hidden = false;
        ratingWidget.hidden = false;
        var empty = ratingRow.querySelector('.clipper-rating-empty');
        if (empty) empty.hidden = true;
      };
      ratingObserver = new MutationObserver(syncRating);
      ratingObserver.observe(ratingWidget, { childList: true, characterData: true, subtree: true });
      syncRating();
    }
    var list = root.querySelector('[data-clipper-benefits]');
    if (!list || list.dataset.clipperBenefitsReady) return;
    if (typeof HTMLDialogElement === 'undefined') return;
    list.dataset.clipperBenefitsReady = 'true';
    var dialogId = 'ClipperBenefitDialog-' + config.sectionId;
    var previous = document.getElementById(dialogId);
    if (previous) previous.remove();
    var titleId = dialogId + '-title';
    var captionId = dialogId + '-caption';
    var dialog = document.createElement('dialog');
    dialog.id = dialogId;
    dialog.className = 'clipper-benefit-dialog';
    dialog.setAttribute('aria-labelledby', titleId);
    dialog.setAttribute('aria-describedby', captionId);
    dialog.innerHTML = '<div class="clipper-benefit-head"><div><p class="clipper-benefit-product"></p><h2></h2></div><button type="button" class="clipper-benefit-close" aria-label="Cerrar detalles del beneficio">&#215;</button></div><figure class="clipper-benefit-figure"><div class="clipper-benefit-image-wrap" hidden><p class="clipper-benefit-status" role="status">Cargando imagen…</p><img class="clipper-benefit-photo" width="1200" height="1200" decoding="async" hidden></div><figcaption></figcaption></figure>';
    dialog.querySelector('h2').id = titleId;
    dialog.querySelector('figcaption').id = captionId;
    dialog.querySelector('.clipper-benefit-product').textContent = config.product;
    document.body.appendChild(dialog);
    var image = dialog.querySelector('img');
    var imageWrap = dialog.querySelector('.clipper-benefit-image-wrap');
    var status = dialog.querySelector('.clipper-benefit-status');
    var closeButton = dialog.querySelector('button');
    var trigger, previousOverflow, backdropDown = false;
    image.addEventListener('load', function () { image.hidden = false; status.hidden = true; });
    image.addEventListener('error', function () { imageWrap.hidden = true; });
    function close() { if (dialog.open) dialog.close(); }
    closeButton.addEventListener('click', close);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('close', function () {
      document.body.style.overflow = previousOverflow || '';
      if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('pointerdown', function (event) {
      var rect = dialog.getBoundingClientRect();
      backdropDown = event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
    });
    dialog.addEventListener('click', function (event) { if (event.target === dialog && backdropDown) close(); backdropDown = false; });
    var hint = document.createElement('p');
    hint.className = 'clipper-benefit-hint';
    hint.textContent = 'Toca un beneficio para verlo de cerca.';
    list.before(hint);
    list.querySelectorAll('.badge').forEach(function (badge, index) {
      var scene = config.scenes[index];
      if (!scene) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = badge.className + ' clipper-benefit-trigger';
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', dialogId);
      while (badge.firstChild) button.appendChild(badge.firstChild);
      var plus = document.createElement('span');
      plus.className = 'clipper-benefit-open';
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';
      button.appendChild(plus);
      button.addEventListener('click', function () {
        trigger = button;
        dialog.querySelector('h2').textContent = scene.title;
        dialog.querySelector('figcaption').textContent = scene.copy;
        imageWrap.hidden = !scene.image;
        if (scene.image) {
          image.hidden = true;
          status.hidden = false;
          image.alt = scene.alt;
          image.src = scene.image;
          if (image.complete && image.naturalWidth) { image.hidden = false; status.hidden = true; }
        }
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        closeButton.focus({ preventScroll: true });
      });
      badge.replaceWith(button);
    });
    root.addEventListener('shopify:section:unload', function () { close(); dialog.remove(); if (ratingObserver) ratingObserver.disconnect(); }, { once: true });
  }
  function init() { document.querySelectorAll('[data-clipper-benefit-config]').forEach(enhance); }
  init();
  document.addEventListener('shopify:section:load', init);
})();
